module.exports = __webpack_public_path__ + "img/Close.42183438.svg";